//  Return true if we can use webp images
let canUse = null
const canusewebp = () => {
	if (canUse !== null) {
		return canUse
	}
	const elem = typeof global.document === 'object' ? global.document.createElement('canvas') : {}

	if (elem.getContext && elem.getContext('2d')) {
		canUse = elem.toDataURL && elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
		return canUse
	}
	canUse = false
	return canUse
}

export default canusewebp



// WEBPACK FOOTER //
// ./src/utilities/canusewebp.js